import { FieldConfig } from "../../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../../DEFAULT/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "../../../../../../../../components/MessageWithLink/types";
export enum TaxableBenefits {
  CAR = "Car",
  CHILDCARE = "Childcare",
  COMMUTER_ALLOWANCE = "Commuter Allowance",
  LIVING_ACCOMMODATIONS = "Living Accommodations",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal Allowance",
  MOVING = "Moving",
  NON_CASH_GIFTS_AND_AWARDS = "Non-Cash Gifts & Awards",
  PHONE_AND_INTERNET = "Phone & Internet",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational Facilities & Dues",
  REMOTE_WORK = "Remote Work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.CHILDCARE]: {
    text: "Tax-exempt up to $5,000 a year if under a dependent care assistance plan (DCAP) for dependents under 13 years of age.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.LOANS]: {
    text: "Imputed interest benefit for loans of over $10,000 is fully taxable.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
